// extracted by mini-css-extract-plugin
export default {"wrap":"progress_wrap__XfWQx","progress":"progress_progress__uOxYo","bar":"progress_bar__iOKzE","text":"progress_text__Q1VyU","marquee":"progress_marquee__Mechq"};